import { atom } from 'jotai';

export const functionWorkspaceRequestAtom = atom<string | null>(null);